<template>
  <!--选做弹框区 -->
  <el-dialog
    title="选做题"
    width="700px"
    class="dialog"
    :visible="value"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('input', false)"
  >
    <el-form inline :model="formData" :rules="rulesFrom" ref="formData">
      <el-form-item label="大题题号：" prop="th">
        <el-select v-model="formData.th" size="small" style="width: 100px">
          <el-option
            v-for="item in ths"
            :key="'th' + item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="limit-title" label="题目名称：" prop="name">
        <el-input
          class="topic_name"
          v-model="formData.name"
          maxlength="27"
          show-word-limit
          size="small"
        ></el-input>
      </el-form-item>
      <div></div>
     
      <div class="el-form-item">
        <label class="el-form-item__label add_x">{{
          "题\xa0\xa0\xa0\xa0\xa0\xa0号："
        }}</label>
        <el-form-item prop="start" ref="start_inp">
          <IntegerInput v-model="formData.start" />
          <!-- <el-input-number v-model="formData.start" :controls="false" size="small" :max="50" :min="1"></el-input-number> -->
        </el-form-item>
        <span class="dia-name">至</span>
        <el-form-item prop="end" ref="end_inp">
          <IntegerInput v-model="formData.end" />
          <!-- <el-input-number v-model="formData.end" :controls="false" size="small" :max="50" :min="1"></el-input-number> -->
          <span>题</span>
        </el-form-item>
         <el-form-item
        :label="'分\xa0\xa0\xa0\xa0\xa0\xa0值：'"
        prop="score"
        class="wh75"
      >
        <el-input-number
          v-model="formData.score"
          :controls="false"
          size="small"
          :min="0.5"
          :precision="2"
        ></el-input-number>
        <span>分</span>
      </el-form-item>
      </div>
      <!-- <el-form-item label="选做题数" prop="value"> -->
      <!--分母值-->
      <!-- <el-input-number v-model="formData.value" :controls="false" size="small" :max="8"></el-input-number>
        <span class="dia-name">题</span>
      </el-form-item>-->

      <!-- <el-form-item>
        <el-button type="primary" icon="el-icon-plus" @click="createItems" circle size="small"></el-button>
      </el-form-item>-->
    </el-form>

    <!-- <div class="dialog-cont">
      <el-button type="text" @click="clearList(true)">清空列表</el-button>
      <div class="dialog-list">
        <el-table class="choose-table" :data="formData.items">
          <el-table-column label="题号" prop="no" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.start" :controls="false" size="mini"></el-input-number>
              <span>~</span>
              <el-input-number v-model="scope.row.end" :controls="false" size="mini"></el-input-number>
            </template>
          </el-table-column>

          <el-table-column label="分值" prop="score" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.score" :controls="false" size="mini"></el-input-number>
            </template>
          </el-table-column>

          <el-table-column label="选做题数">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.value" :controls="false" size="mini"></el-input-number>
            </template>
          </el-table-column>

          <el-table-column label="操作" prop="action" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="deleteItem(scope)" icon="el-icon-delete"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="dialogSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { ChooseModel } from "./Choose.model.js";
import { mapState } from "vuex";
import { initTopicBoxMixins } from '../../mixins/initTopicBoxFormData.mixins'
export default {
  name: "Choose",
  props: ["value", "subject"],
  mixins: [initTopicBoxMixins],
  computed: {
    ...mapState("card", {
      ths: (state) => state.THS,
    }),
  },
  data(ctx) {
    var thValidate = (rule, value, callback) => {
      value = Number(value);
      let validV = new RegExp("^([1-9]\\d{0,}\\.){0,2}[1-9]\\d{0,}$");
      if (!value) {
        console.log(ctx.formData.end);
        callback(new Error("必填"));
      } else if (!validV.test(value)) {
        callback(new Error("请正确填写"));
      } else if (rule.field === "start" && value > Number(ctx.formData.end)) {
        callback(new Error("开始题号过大"));
      } else if (rule.field === "end" && value < Number(ctx.formData.start)) {
        callback(new Error("开始题号过大"));
      } else if (
        rule.field === "end" &&
        value >= Number(ctx.formData.start) + 5
      ) {
        callback(new Error("选做题目不超过5题"));
      } else {
        if (rule.field === "start") {
          this.$refs["end_inp"].clearValidate();
        } else {
          this.$refs["start_inp"].clearValidate();
        }
        callback();
      }
    };
    return {
      formData: new ChooseModel(),
      rulesFrom: {
        th: [{ required: true, message: "必填", trigger: "blur" }],
        name: [{ required: true, message: "必填", trigger: "blur" }],
        score: [{ required: true, message: "必填", trigger: "blur" }],
        start: [{ validator: thValidate, trigger: "blur" }],
        end: [{ validator: thValidate, trigger: "blur" }],
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    createItems() {
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          this.formData = new ChooseModel(this.formData);
        } else {
        }
        // this.formData.addItem();
      });
    },

    clearList() {
      this.formData.items = [];
    },

    dialogClose() {
      if (this.subject) {
        this.subject.oldSubject =
          this.subject && JSON.parse(JSON.stringify(this.subject));
      }
      this.$emit("input", false);
    },
    dialogSubmit() {
      if (this.submitDisabled) {
        return false;
      }
      this.submitDisabled = true;
      let timer = setTimeout(() => {
        this.submitDisabled = false;
        clearTimeout(timer);
      }, 500);
      // if (!this.formData.items.length) return;
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          console.log("点击确认", this.formData);
          this.formData = new ChooseModel(this.formData);
          this.$emit("submit-choose", this.formData);
          if (this.subject) {
            this.subject.oldSubject =
              this.subject && JSON.parse(JSON.stringify(this.subject));
          }
        } else {
        }
        // this.formData.addItem();
      });
    },
    deleteItem(scope) {
      const idx = scope.$index;
      this.formData.deleteItem(idx);
    },
  },
  watch: {
    value: {
      //handler:'test',
      handler(val) {
        if (val) {
          if (this.subject) {
            this.subject.oldSubject =
              this.subject && JSON.parse(JSON.stringify(this.subject));
          }
          this.subject
            ? (this.formData = new ChooseModel(this.subject.oldSubject))
            : (this.formData = new ChooseModel(this.type));
          this.clearHistoryTopicFormData()
        }
      },
      immediate: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" scoped>
.choose-table {
  .el-input-number {
    width: 50px;
  }
  .el-input-number + span {
    padding: 0 10px;
  }
}
</style>
